import { render } from "./InicioAdmins.vue?vue&type=template&id=3abe519e&scoped=true"
import script from "./InicioAdmins.vue?vue&type=script&lang=js"
export * from "./InicioAdmins.vue?vue&type=script&lang=js"

import "./InicioAdmins.vue?vue&type=style&index=0&id=3abe519e&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abe519e"]])

export default __exports__